import React from 'react';
import { blogPosts } from '../data/mock';
import { ArrowRight, Clock } from 'lucide-react';

const Blog = () => {
  return (
    <section id="blog" className="section-padding bg-[#f8f7f2]">
      <div className="container-custom">
        {/* Section header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <div className="gold-accent mb-6"></div>
            <h2 className="font-serif text-3xl md:text-4xl text-[#2d2d2d] mb-4">
              Health Education & Insights
            </h2>
            <p className="text-[#5a5a5a] text-lg leading-relaxed">
              Stay informed with the latest in preventative care, wellness strategies, 
              and medical insights from our practice.
            </p>
          </div>
          <a href="#" className="text-link flex items-center gap-2 text-[#2d2d2d] hover:text-[#c9a962] transition-colors">
            View All Articles
            <ArrowRight size={16} />
          </a>
        </div>

        {/* Featured post */}
        <div className="mb-12">
          <div className="grid lg:grid-cols-2 gap-8 bg-[#fffef8] card-hover">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={blogPosts[0].image}
                alt={blogPosts[0].title}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-4 mb-4">
                <span className="text-xs text-[#c9a962] tracking-wider uppercase">
                  {blogPosts[0].category}
                </span>
                <span className="w-1 h-1 bg-[#d0cfc8] rounded-full"></span>
                <span className="text-xs text-[#8a8a8a]">{blogPosts[0].date}</span>
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-[#2d2d2d] mb-4">
                {blogPosts[0].title}
              </h3>
              <p className="text-[#5a5a5a] leading-relaxed mb-6">
                {blogPosts[0].excerpt}
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 text-[#8a8a8a] text-sm">
                  <Clock size={14} />
                  <span>{blogPosts[0].readTime}</span>
                </div>
                <a href="#" className="btn-primary text-sm py-3 px-6">
                  Read Article
                  <ArrowRight size={14} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Blog grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.slice(1).map((post) => (
            <article key={post.id} className="bg-[#fffef8] card-hover group">
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 mb-3">
                  <span className="text-xs text-[#c9a962] tracking-wider uppercase">
                    {post.category}
                  </span>
                  <span className="w-1 h-1 bg-[#d0cfc8] rounded-full"></span>
                  <span className="text-xs text-[#8a8a8a]">{post.date}</span>
                </div>
                <h3 className="font-serif text-xl text-[#2d2d2d] mb-3 group-hover:text-[#c9a962] transition-colors">
                  {post.title}
                </h3>
                <p className="text-sm text-[#8a8a8a] leading-relaxed mb-4">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-[#8a8a8a] text-xs">
                    <Clock size={12} />
                    <span>{post.readTime}</span>
                  </div>
                  <a href="#" className="text-sm text-[#2d2d2d] hover:text-[#c9a962] transition-colors flex items-center gap-1">
                    Read More
                    <ArrowRight size={14} />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
